import React from 'react';
import { GlobalDesignActionPanel } from '../types';
import { ControlsServiceProvider } from '../../automaticPanel/panelsService/ControlsServiceContext';
import { ShadowControlsGuard } from './components/ShadowControlsGuard';

const ShadowStyles: GlobalDesignActionPanel = (props) => {
  return (
    <ControlsServiceProvider host={props.host}>
      <ShadowControlsGuard />
    </ControlsServiceProvider>
  );
};

export default ShadowStyles;
